import {
    SET_CAP_DOWN_PAYMENT,
    SET_CAP_TERM,
    SET_SHOW_CAP,
    SET_CAP,
} from './constants';

const defaultState = {
    capDownPayment: 10000,
    capTerm: 84,
    showCAP: false,
};

const cap = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CAP_DOWN_PAYMENT:
            return { ...state, capDownPayment: action.capDownPayment };

        case SET_CAP_TERM:
            return { ...state, capTerm: action.capTerm };

        case SET_SHOW_CAP:
            return { ...state, showCAP: action.showCAP };
        case SET_CAP:
            return {
                capTerm: action.cap.termInMonths,
                capDownPayment: action.cap.downPayment,
                showCAP: action.cap.showCap,
            };


        default:
            return state;
    }
};

export default cap;



// WEBPACK FOOTER //
// ./src/containers/common/cap/reducer.js